<template>
  <div class="invite-main">
    <div class="section-title">{{ $t('stepTitle') }}</div>
    <div class="invite-step">
      <div class="step-item" v-for="(i, index) in stepList" :key="index">
        <div class="step-icon">
          <img :src="i.icon">
        </div>
        <div class="step-content">
          <div class="step-name">{{ i.stepName }}</div>
          <div class="step-title">{{ i.title }}</div>
          <div class="step-desc">
            <div v-for="(j, index) in i.descList" :key="index">{{ j }}</div>
          </div>
        </div>
      </div>
      <div class="invite-tip">
        <div>{{ $t('inviteTip1') }}</div>
        <div>{{ $t('inviteTip2') }}</div>
      </div>
      <div class="section-title">
        {{ $t('recordTitle') }}
      </div>
      <div class="record">
        <div class="total-reward">
          <span class="label">{{ $t('totalReward') }}</span>
          <span class="value">{{ totalReward | formatMoney }}</span>
        </div>
        <div class="record-list">
          <div class="record-title">
            <div class="record-title-item" :style="{'width': i.width}" v-for="(i, index) in recordTitle" :key="index">
              {{ i.text }}
            </div>
          </div>
          <div class="record-detail">
            <div v-if="recordList.length">
              <div v-for="(i, index) in recordList" :key="index" class="record-item">
                <div style="width: 24%;text-align: center;">{{i.rewardTypeDesc}}</div>
                <div style="width: 24%;text-align: center;">{{i.rewardAmount | formatMoney}}</div>
                <div style="width: 28%;text-align: center;">{{i.mobile}}</div>
                <div style="width: 24%;text-align: center;">{{i.rewardTime}}</div>
              </div>
            </div>
            <div v-else class="no-data">
              {{ $t('noData') }}
            </div>
          </div>
        </div>
      </div>
      <div>
        <md-button class="btn-term" plain round @click="goRulePage">
          {{ $t('termAndCondition') }}
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Button } from 'mand-mobile'

export default {
  i18n: {
    messages: {
      en: {
        stepTitle: 'Get Rp 50.000 in 3 Steps',
        recordTitle: 'My Referal Record',
        inviteTip1: '· After your friends successfully register, You can get up to Rp 150.000 (max 3 people) every month.',
        inviteTip2: '· You can get 1% from total funding for 6 months',
        totalReward: 'Total Reward:',
        step1: 'Share Referral Link',
        step1Desc: 'Click the Invite Friends button below, the link will be copied to the clipboard automatically, paste the link in another application',
        step2: 'Friend Verification',
        step2Desc: 'Tell friends to register and complete onboarding process, after verification you will get Rp 50.000 voucher',
        step3: 'Take Your Gift',
        step3Desc1: 'Go to Account-Discount-Coupon to see voucher.',
        step3Desc2: 'Your friend will get Rp 9.999 cashback and 1% interest bonus after registration',
        rewardType: 'Reward Type',
        amount: 'Amount',
        friendName: 'Friend\'s Name',
        time: 'Time',
        termAndCondition: 'Terms and Conditions',
        noData: 'No Data',
        KYC: 'Friend verified',
        INVEST: 'Friend invested',
      },
      id: {
        stepTitle: 'Dapatkan Rp 50.000 dengan 3 langkah',
        recordTitle: 'Catatan Referal Saya',
        inviteTip1: '· Setelah temanmu berhasil register, kamu akan mendapatkan max Rp 150.000 ( max 3 orang) setiap bulan.',
        inviteTip2: '· Kamu akan mendapatkan 1% dari total pendanaan selama 6 bulan',
        totalReward: 'Jumlah Hadiah:',
        step1: 'Bagikan Link Referal',
        step1Desc: 'Klik tombol Undang Teman dibawah, link akan tersalin ke clipboard secara otomatis, tempelkan link di aplikasi lain',
        step2: 'Verifikasi Teman',
        step2Desc: 'Beri tahu teman untuk daftar dan menyelesaikan proses verifikasi, setelah verifikasi kamu akan mendapat voucher Rp 50.000',
        step3: 'Ambil Hadiah Kamu',
        step3Desc1: 'Masuk ke Akun-Diskon-Coupon untuk melihat voucher.',
        step3Desc2: 'Teman kamu akan mendapatkan cashback Rp 9.999 dan bonus bunga 1% setelah mendaftar',
        rewardType: 'Jenis Hadiah',
        amount: 'Jumlah',
        friendName: 'Nama Teman',
        time: 'Waktu',
        termAndCondition: 'Syarat dan Ketentuan',
        noData: 'No Data',
        KYC: 'Teman terverifikasi',
        INVEST: 'Teman mendanai',
      },
    },
  },
  components: {
    [Button.name]: Button,
  },
  data() {
    return {
      stepList: [
        {
          icon: require('@/assets/image/activity/invite/icon-step1.png'),
          stepName: 'Step 1',
          title: this.$t('step1'),
          descList: [this.$t('step1Desc')],
        },
        {
          icon: require('@/assets/image/activity/invite/icon-step2.png'),
          stepName: 'Step 2',
          title: this.$t('step2'),
          descList: [this.$t('step2Desc')],
        },
        {
          icon: require('@/assets/image/activity/invite/icon-step3.png'),
          stepName: 'Step 3',
          title: this.$t('step3'),
          descList: [this.$t('step3Desc1'), this.$t('step3Desc2')],
        },
      ],
      totalReward: 0,
      recordTitle: [
        { text: this.$t('rewardType'), width: '24%' },
        { text: this.$t('amount'), width: '24%' },
        { text: this.$t('friendName'), width: '28%' },
        { text: this.$t('time'), width: '24%' },
      ],
      recordList: [],
    }
  },
  mounted() {
    this.getInviteRecord()
  },
  methods: {
    async getInviteRecord() {
      try {
        const response = await this.$http.get('/invitation/invitees')
        const data = response.data.data
        let totalReward = 0
        data.forEach(i => {
          totalReward += i.rewardAmount
          i.rewardTime = this.moment(i.rewardTimestamp).format('YYYY/MM/DD')
          i.rewardTypeDesc = this.$t(i.rewardType)
        })
        this.recordList = data || []
        this.totalReward = totalReward
      } catch (error) {
        console.log(error)
      }
    },
    goRulePage() {
      this.$router.push({ name: 'InviteRule' })
    },
  },
}
</script>

<style scoped lang="stylus">
.invite-main {
  background-image: url("../../../assets/image/activity/invite/bg-main.png");
  background-size: 100% 100%;
  margin-top: -40px;
  padding: 80px 15px 35px;
}

.section-title {
  color: #fff;
  font-size: 21px;
  font-weight: bold;
  line-height: 26px;
  text-shadow: 0px 1px 2px rgba(10, 0, 69, 0.5);
  margin-bottom: 25px;
}

.step-item {
  background-color: #fff;
  padding: 24px 20px;
  border-radius: 6px;
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .step-icon {
    margin-right: 20px;
    img {
      width: 84px;
      height: 91px;
    }
  }
  .step-name {
    font-style: italic;
    font-size: 21px;
    line-height: 26px;
    font-weight: 600;
    color: #23c88f;
    margin-bottom: 2px;
  }
  .step-title {
    color: #2c2e38;
    font-size: 15px;
    font-weight: bold;
    line-height: 20px;
    margin-bottom: 2px;
  }
  .step-desc {
    font-size: 12px;
    line-height: 15px;
    font-weight: 500;
    color: #2c2e38;
  }
}

.invite-tip {
  border: 1px solid #fff;
  border-radius: 5px;
  padding: 8px 10px;
  color: #fff;
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
  margin-bottom: 35px;
}

.total-reward, .record-list {
  background-color: #108049;
  border-radius: 5px;
  color: #fff;
}

.total-reward {
  padding: 16px 12px;
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .label {
    font-size: 12px;
    margin-right: 8px;
  }
  .value {
    font-family: 'Reducto';
    font-size: 22px;
    line-height: 26px;
  }
}

.record-list {
  padding: 15px 10px;
  font-size: 12px;
  line-height: 16px;
  color: #fff;
  .record-title {
    display: flex;
    justify-content: space-between;
    padding-bottom: 15px;
    border-bottom: 1px solid #fff;
    .record-title-item {
      flex-wrap: wrap;
      align-self: center;
      text-align: center;
    }
  }
  .record-detail {
    max-height: 400px;
    overflow-y: scroll;
    .record-item {
      padding-top: 10px;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
    }
  }
}

.btn-term {
  margin: 35px auto 0;
  font-size: 15px;
  width: auto;
}
</style>
